import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useRef } from 'react';
import VendorMonthGraph from '../../components/Vendors/Dashboard/VendorGraph.jsx';
import FilterVendorCalendar from '../../components/Vendors/Dashboard/FilterVendorCalendar';
import VendorAmountOverview from '../../components/Vendors/Dashboard/VendorAmountOverview';
import RecentVendorInvoices from "../../components/Vendors/Dashboard/RecentVendorInvoice.jsx";
import { motion } from 'framer-motion';

export default function VendorDashboard() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user)
  const sum = useSelector((state) => state.invoice.vendorDashboardCurrencySum)
  const componentRef = useRef(null);
  useEffect(() => {
    componentRef.current.scrollTop = 0;
  }, [dispatch, user]);

  const fadeIn = {
    hidden: { opacity: 0 , scale: 0.97},
    visible: { opacity: 1 , scale: 1}
  };

  return (
    <motion.div
      ref={componentRef}
      initial="hidden"
      animate="visible"
      variants={fadeIn}
      transition={{ duration: 0.18 }}
    >
      <div ref={componentRef}>
        <>
          <div className='filter-sec'>
            <FilterVendorCalendar sum={sum} />
          </div>
          <div className='graph-overview'>
            <div className='overview-left'>
              <VendorAmountOverview sum={sum} />
            </div>
            <VendorMonthGraph sum={sum} />
          </div>
          <div className='recent-invoices'>
            <div className='recent-invoice-inner'>
              <RecentVendorInvoices sum={sum} />
            </div>
          </div>
        </>
      </div>
    </motion.div>
  )
}